import React from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../components/HeaderTabLayout'
import Layout from '../components/Layout'
import Loader from '../components/Loader'
import PositionView from '../components/version-4/viewForms/PositionView'
import { usePosition } from '../hooks/CompanyConfiguration/usePosition'
import { useCategory } from '../hooks/Features/useCategory'
import { useFeatures } from '../hooks/Features/useFeatures'
import { ROUTES } from '../shared/constants'

function ViewPosition() {
  const { getPosition, position } = usePosition()
  const params = useParams()

  React.useEffect(() => {
    getPosition({ positionId: params.positionId })
  }, [params.positionId])

  return (
    <Layout heading="Position" heading2="Info" url1={ROUTES.POSITION} none>
      {/* {category ? ( */}
      <HeaderTabLayout
        heading="Position"
        content={<PositionView position={position} />}
        view
        url={`/edit-position/${params.positionId}`}
      />
      {/* ):<Loader/>} */}
    </Layout>
  )
}

export default ViewPosition
